import { notifyAppInitializationFailure } from '@ms/yammer-web-support/dist/metaOsHub';
import { PureComponent } from 'react';

export interface ErrorBoundaryState {
  readonly error: Error | undefined;
}

export default class AppErrorBoundary extends PureComponent {
  public state: ErrorBoundaryState = {
    error: undefined,
  };

  public static getDerivedStateFromError(error: Error) {
    return { error };
  }

  public componentDidCatch(error: Error) {
    notifyAppInitializationFailure(error);
  }

  public render() {
    const { children } = this.props;

    return this.state.error ? null : children;
  }
}
